import * as server from '@/utils/server-wrapper'
export function saveActionRecord( data ) {
  return server.postJsonReturn('/actionRecord/add', data)
}



// WEBPACK FOOTER //
// ./src/api/buriedPoint.js